import { Row, Col, Form, Button } from 'antd';
import React, { useEffect, useState } from 'react';
import DynamicChart from '../pages/DynamicChart';
import { useLocation } from 'react-router-dom';
import queryString from "query-string";
import moment from 'moment';


const DynamicCharts = ({
    label,
    name,
    form,
    LocalDict,
    defaultValue
}) => {

    const { search } = useLocation();
    const urlParams = queryString.parse(search);
    const [chartLists, setChartLists] = useState([]);

    const addChart = () => {
        let newdivid =  moment().valueOf().toString();
        // if (!chartLists.length) {
        //     newdivid = 'new-1231312312312321';
        // } else {
        //     let lastdivid = chartLists[chartLists.length - 1].divid;
        //     if (lastdivid.includes('new-')) {
        //         console.log(parseInt(lastdivid.split('new-')[1]));
        //         newdivid = 'new-' + (parseInt(lastdivid.split('new-')[1]) + 1);
        //         console.log(newdivid);
        //     } else {
        //      //   let lastNewId = chartLists.find
        //     }
        // }
        setChartLists([...chartLists, { typ: 'ZenVerBarChart', divid: newdivid, isVirgin: true }])
    };

    const setchartid = (index, chartid) => {
        let charts = [...chartLists];
        charts[index].chartid = chartid;
        setChartLists(charts);
    }
    useEffect(() => {
        if(defaultValue){
            setChartLists(defaultValue);
        }
    }, []);

    useEffect(() => {
        form.setFieldsValue({ [name]: chartLists });
    }, [chartLists]);

    const deleteChart = (divid) => {
        setChartLists(chartLists.filter((x) => x.divid !== divid))
    }
    return (
        <div className='ant-form-item'>
            <Form.Item hidden name={name} />
            <Row className='ant-form-item-row'>
                <Col span={24} className='ant-form-item-label' style={{ display: 'inline-flex', justifyContent: 'space-between' }}>
                    <label className='ant-form-item-no-colon' title={label}>{label}</label>
                    <Button onClick={addChart} type="primary">Add New</Button>
                </Col>
                <Col span={24} className='ant-form-item-control'>
                    <div style={{ borderRadius: 7, border: '1px solid grey', minHeight: 150, display: 'inline-flex', flexWrap: 'wrap', width: '100%' }}>
                        {
                            chartLists.map((x, i) => (
                                <DynamicChart
                                    divid={x.divid}
                                    currentChart={x}
                                    chartid={x.chartid}
                                    setchartid={(chartid) => setchartid(i, chartid)}
                                    urlParams={urlParams}
                                    LocalDict={LocalDict}
                                    chart={x.typ}
                                    onDelete={() => deleteChart(x.divid)}
                                    chartLists={chartLists}
                                    setChartLists={setChartLists}
                                />
                            ))
                        }
                    </div>
                </Col>
            </Row>
        </div>
    )
};

export default DynamicCharts;